import HeadingNav from '../../../components/Layouts/HeadingNav';
import { useLocation, Redirect, useParams } from 'react-router-dom';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIRouterTabs from 'ui-addon-react-router-dom/UIRouterTabs';
import UIRouterTab from 'ui-addon-react-router-dom/UIRouterTab';
import { ListingPage } from 'foundations-components/transitional/components/ListingPage';
import CertificationsByTeamActiveTab from '../components/certificationsByTeam/CertificationsByTeamActiveTab';
import CertificationsByTeamInProgressTab from '../components/certificationsByTeam/CertificationsByTeamInProgressTab';
import CertificationsByTeamExpiredTab from '../components/certificationsByTeam/CertificationsByTeamExpiredTab';
import { ACTIVE_CERTIFICATIONS_BY_TEAM_PATH, EXPIRED_CERTIFICATIONS_BY_TEAM_PATH, IN_PROGRESS_CERTIFICATIONS_BY_TEAM_PATH } from '../constants/routes';
import { useEffect, useMemo } from 'react';
import UsageTracker from '../../../utils/UsageTracker';
import { PAGE_NAMES } from '../../../constants/Navigation';
import { trackCertificationStatusChange } from '../utils/trackingUtils';
import TabLiner from '../components/common/TabLiner';
import { HasGate } from '../../accounts';
import { View } from 'foundations-components/components/View';
import { PageHeader } from '../../header/components/PageHeader';
import { FiltersCard } from '../../filters/components/FiltersCard';
import I18n from 'I18n';
import TabsSelect from '../components/filters/TabsSelect';
import Card from '../components/common/Card';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const RedirectToCertificationsByTeamDefaultTab = () => {
  const location = useLocation();
  const {
    pathname
  } = location;
  return /*#__PURE__*/_jsx(Redirect, {
    to: Object.assign({}, location, {
      pathname: `${pathname}/active`
    })
  });
};
const MyTeamCertificationsByTeam = () => {
  const {
    certificationStatus
  } = useParams();
  useEffect(() => {
    UsageTracker.track('pageView', {
      screen: PAGE_NAMES.MY_TEAM_CERTIFICATIONS_BY_TEAM
    });
  }, []);
  useEffect(() => {
    trackCertificationStatusChange(certificationStatus);
  }, [certificationStatus]);
  const pathToTitleMap = useMemo(() => {
    return {
      [ACTIVE_CERTIFICATIONS_BY_TEAM_PATH]: I18n.text('learningCenter.myTeam.certificationStatus.active'),
      [EXPIRED_CERTIFICATIONS_BY_TEAM_PATH]: I18n.text('learningCenter.myTeam.certificationStatus.expired'),
      [IN_PROGRESS_CERTIFICATIONS_BY_TEAM_PATH]: I18n.text('learningCenter.myTeam.certificationStatus.inProgress')
    };
  }, []);
  return /*#__PURE__*/_jsx(HasGate, {
    fallback: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(HeadingNav, {
        subtitleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.heading.headingSubTitles.MY_TEAM_CERTIFICATIONS_BY_TEAM"
        }),
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.heading.headingTitles.MY_TEAM_CERTIFICATIONS_BY_TEAM"
        })
      }), /*#__PURE__*/_jsx(ListingPage, {
        headerComponent: null,
        children: /*#__PURE__*/_jsxs(UIRouterTabs, {
          children: [/*#__PURE__*/_jsx(UIRouterTab, {
            active: certificationStatus === 'active',
            replace: true,
            title: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.myTeam.certificationStatus.active"
            }),
            to: ACTIVE_CERTIFICATIONS_BY_TEAM_PATH,
            children: /*#__PURE__*/_jsx(TabLiner, {
              children: /*#__PURE__*/_jsx(CertificationsByTeamActiveTab, {})
            })
          }), /*#__PURE__*/_jsx(UIRouterTab, {
            active: certificationStatus === 'expired',
            replace: true,
            title: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.myTeam.certificationStatus.expired"
            }),
            to: EXPIRED_CERTIFICATIONS_BY_TEAM_PATH,
            children: /*#__PURE__*/_jsx(TabLiner, {
              children: /*#__PURE__*/_jsx(CertificationsByTeamExpiredTab, {})
            })
          }), /*#__PURE__*/_jsx(UIRouterTab, {
            active: certificationStatus === 'in-progress',
            replace: true,
            title: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.myTeam.certificationStatus.inProgress"
            }),
            to: IN_PROGRESS_CERTIFICATIONS_BY_TEAM_PATH,
            children: /*#__PURE__*/_jsx(TabLiner, {
              children: /*#__PURE__*/_jsx(CertificationsByTeamInProgressTab, {})
            })
          })]
        })
      })]
    }),
    gate: "Academy:UnifiedAcademy:Navigation",
    children: /*#__PURE__*/_jsxs(View, {
      children: [/*#__PURE__*/_jsx(PageHeader, {
        subtitle: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.heading.headingSubTitles.MY_TEAM_CERTIFICATIONS_BY_TEAM"
        }),
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.heading.headingTitles.MY_TEAM_CERTIFICATIONS_BY_TEAM"
        })
      }), /*#__PURE__*/_jsx(FiltersCard, {
        children: /*#__PURE__*/_jsx(TabsSelect, {
          pathsToTitleMap: pathToTitleMap
        })
      }), /*#__PURE__*/_jsxs(Card, {
        children: [certificationStatus === 'active' && /*#__PURE__*/_jsx(CertificationsByTeamActiveTab, {}), certificationStatus === 'expired' && /*#__PURE__*/_jsx(CertificationsByTeamExpiredTab, {}), certificationStatus === 'in-progress' && /*#__PURE__*/_jsx(CertificationsByTeamInProgressTab, {})]
      })]
    })
  });
};
export default MyTeamCertificationsByTeam;